import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { Icon } from '@/new/components/icon';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/new/components/shadcn/tooltip';
import { cn } from '@/new/lib/utils';

interface ExtractFactsFromSelectionButtonProps {
  isSelectionMode: boolean;
  setIsSelectionMode: (mode: boolean) => void;
  docId: string;
}

export const ExtractFactsFromSelectionButton = ({
  isSelectionMode,
  setIsSelectionMode,
  docId,
}: ExtractFactsFromSelectionButtonProps) => {
  return (
    <TooltipProvider delayDuration={0} skipDelayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            onClick={() => {
              if (!isSelectionMode) {
                trackCustomEvent(TrackingEventsV2.SelectToCreateFactFromImageSelection, { docId });
              }
              setIsSelectionMode(!isSelectionMode);
            }}
            className={cn(
              'group flex cursor-pointer items-center rounded-lg border-2 border-blue-300 bg-blue-50 px-1.5 py-1 shadow-xl transition-all hover:border-blue-400 hover:bg-blue-100',
              isSelectionMode && 'border-blue-400 bg-blue-400 text-white hover:border-blue-400 hover:bg-blue-400',
            )}
            style={{ position: 'relative' }}
          >
            <Icon
              className={cn(
                'lucide--crop h-4 w-4 text-blue-600 transition-transform group-hover:scale-110',
                isSelectionMode && 'text-white',
              )}
            />
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{isSelectionMode ? 'Exit selection mode' : 'Select an area of the document to extract facts from it.'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
